export const enum Screen {
  Amount = "amount",
  Details = "details",
  Success = "success",
}

export const enum DetailsStep {
  YourDetails = "your-details",
  YourAddress = "your-address",
  SelectCard = "select-card",
  DonationInformation = "donation-information",
  PaymentType = "payment-type",
  CardDetails = "card-details",
  ConfirmDetails = "confirm-details",
  BankDetails = "bank-details",
  ThankYouPage = "thank-you-page",
}
